// @flow
import React, { useContext, useState, useEffect } from 'react';
import { get } from 'lodash';

import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { CORE_GET_FACEBOOK_CONNECT_CONFIG } from 'Utils/request/requestDictionary';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';

import ReactAppContext from 'Context/ReactAppContext';
import { MemberSignIn } from './MemberSignIn.jsx';

type Props = {
  cmsContentAuthentication: CMSAccountAuthentication,
};

const query = `
  query {
    facebookConnect {
      isAvailable
    }
    wechatConnect {
      isAvailable
    }
  }
`;

export function MemberSignInContainer({ cmsContentAuthentication }: Props) {
  const appContext = useContext(ReactAppContext);
  const [isFacebookConnect, setIsFacebookConnect] = useState(false);
  const [isWechatConnect, setIsWechatConnect] = useState(false);

  const { data, isLoading } = useGQL({
    query,
    queryOptions: {
      requestName: CORE_GET_FACEBOOK_CONNECT_CONFIG,
    },
    cache: true,
  });

  useEffect(
    () => {
      setIsFacebookConnect(get(data, 'facebookConnect.isAvailable', false));
      setIsWechatConnect(get(data, 'wechatConnect.isAvailable', false));
    },
    [isLoading],
  );

  return (
    <MemberSignIn
      hasFacebookConnect={isFacebookConnect}
      hasQuickLogin={isFeatureFlipped(appContext)('navigationBar.hasQuickLogin')}
      hasWechatConnect={isWechatConnect}
      join={{
        ctaLabel: get(cmsContentAuthentication, 'createAccountLinkLabel'),
        text: get(cmsContentAuthentication, 'newToClubMed'),
      }}
      quickLogin={{
        ctaLabel: get(cmsContentAuthentication, 'quickLogin.cta'),
        text: get(cmsContentAuthentication, 'quickLogin.text'),
        title: get(cmsContentAuthentication, 'quickLogin.title'),
        keyPoint: get(cmsContentAuthentication, 'quickLogin.keyPoint'),
      }}
      signin={{
        ctaLabel: get(cmsContentAuthentication, 'signin'),
        text: get(cmsContentAuthentication, 'yourAccount.text'),
        title: get(cmsContentAuthentication, 'yourAccount.title'),
      }}
    />
  );
}
